<template>
    <div>
        <div id="payment-form">
            <stripe-element-card ref="stripeElementCard" :pk="spk" @token="addPaymentMethod"></stripe-element-card>
        </div>
        <!-- Below the card field rather than beside it: the field needs the full width to stay
             readable in a narrow modal, and the action reads as the step that follows entry. -->
        <div class="mt-2">
            <b-button variant="success" size="sm" @click="submit" v-if="!saving" :disabled='disabled'>Add
                Card</b-button>
            <span v-else>
                <b-spinner label="Spinning" class="mr-2"></b-spinner>
                <strong>Adding...</strong>
            </span>
        </div>
    </div>
</template>
<script lang='ts'>
import { NotificationOptions } from '@/util/NotificationOptionsPresets';
import { Component, Vue, Prop, Ref } from 'vue-property-decorator';
import { CustomerInfo, Payment, StripeCard } from '@/models/Payment';
import { StripeElementCard } from '@vue-stripe/vue-stripe';
import { Patient } from '@/models/Patient';

@Component({
    name: "StripeVueCard",
    components: {
        StripeElementCard
    }
})
export default class StripeVueCard extends Vue {
    @Ref('stripeElementCard') stripeElementCard!: StripeElementCard;
    @Prop() patient!: Patient;
    @Prop({ default: false }) disabled!: boolean;
    // When set, the card is attached through this endpoint and only the Stripe token is sent — the
    // server decides which customer it belongs to. AR uses this so a card added while taking a
    // payment lands on the account's responsible party, who is not always the patient on screen.
    @Prop({ default: null }) postUrl!: string | null;
    private spk!: string;
    private saving = false;

    submit() {
        if (this.stripeElementCard) (this.stripeElementCard as any).submit();
    }

    beforeCreate() {
        this.spk = this?.$config?.VITE_STRIPE_PUBLIC_KEY;
    }
    addPaymentMethod(token: any) {
        this.saving = true;

        const cardToken = token?.id;
        if (!cardToken) {
            this.$notification(
                NotificationOptions.notificationOptionsPreset('Error getting token from stripe', NotificationOptions.NotificationTypes.danger)
            );
            return;
        }

        let customerInfo = {
            patientId: this.patient?.id,
            name: this.patient?.lastName + ', ' + this.patient?.firstName,
            id: this.patient?.stripeCustomerId
        };
        const request = this.postUrl
            ? this.$http.post(this.postUrl, { cardToken })
            : this.$http.post(`/stripe/${cardToken}`, customerInfo);
        request
            .then(response => {
                if (response.data?.customerId) {
                    this.$notification(NotificationOptions.successSaveNotificationPreset("Card"))
                    this.$emit('cardAdded', response.data)
                }
            })
            .catch(error => {
                this.$notification(NotificationOptions.error(error));
                console.log("Error while adding a card", { error, response: error.response })
            })
            .finally(() => this.saving = false);
    }

}
</script>

<style scoped></style>
